

export const priceValue = (f_sellout, price, cnt_stock, seller, domain) => {
    let response = {
        isShow: false,
        price: price,
        statusText: ''
    }

    if (f_sellout === 2 || f_sellout === 12) {
        response.statusText = domain === 'minishop' ? '-' : '단종된 상품'
        return response
    } else if (f_sellout === 1 || f_sellout === 11 || price === 0 || !seller) {
        response.statusText = domain === 'minishop' ? '일시품절' : '가격비교예정'
        return response
    } else if (cnt_stock === 0) {
        response.statusText = '일시품절'
        return response
    } else if (isPrice(f_sellout, price, cnt_stock, seller)) {
        response = {
            ...response,
            isShow: true,
        }
        return response
    }
}

export const isPrice = (f_sellout, price, cnt_stock, seller) => {
    return f_sellout === 0 && cnt_stock > 0 && price !== 0 && seller !== 0
}



// WEBPACK FOOTER //
// ./src/estimate_list/utils/priceValue.js